import { PUBLIC_RECAPTCHA_SITE_KEY } from '$env/static/public';

type Grecaptcha = {
  ready(callback: () => void): void;
  execute(siteKey: string, options: { action: string }): Promise<string>;
};

// Never app-wide: the badge may hide only beside the attribution line.
export function loadRecaptcha(): () => void {
  const src = `https://www.google.com/recaptcha/api.js?render=${PUBLIC_RECAPTCHA_SITE_KEY}`;
  if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.append(script);
  }
  document.body.classList.add('recaptcha-page');
  return () => document.body.classList.remove('recaptcha-page');
}

// The timeout covers a blocked gstatic.
export async function recaptchaToken(action: string): Promise<string> {
  const grecaptcha = (window as unknown as { grecaptcha?: Grecaptcha }).grecaptcha;
  if (!grecaptcha) throw new Error('reCAPTCHA did not load');
  await Promise.race([
    new Promise<void>((resolve) => grecaptcha.ready(resolve)),
    new Promise<never>((_, reject) => setTimeout(() => reject(new Error('reCAPTCHA did not start')), 10_000)),
  ]);
  return grecaptcha.execute(PUBLIC_RECAPTCHA_SITE_KEY, { action });
}
